import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  inset: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15vh 15vw;
  padding: 15dvh 15dvw;
  background: var(--background);
`;

export const Image = styled.img`
  width: 200px;
  height: 200px;
  position: absolute;
  top: 33%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
